import React from 'react';
import styles from './Contact.css';
import Form from '../Form/Form'; 



export default function Contact() {
  return (
    <section id='contact' className='contact'>
        <div className="contact-container">
            <h5>35,000+ already joined</h5>
            <h2>Stay up-to-date with what we’re doing</h2>
            <div className="contact-form-container">
                <Form />
            </div>
        </div>
    </section>
  )
}
